<template>
  <div id="app">
    <div class="top-tip" v-if="!isMainstreamBrowserShow">
        <img class="broswer-tips" src="./assets/images/broswer_tips@2x.png" alt="">温馨提示：您当前的浏览器版本过低，存在安全风险，建议尽快升级（推荐使用谷歌浏览器，360浏览器极速模式，qq浏览器）
        <img class="broswer-close"   @click="closeTip" src="./assets/images/broswer_close@2x.png" alt="">
    </div>
    <router-view style="height:100%"/>
  </div>
</template>

<script>
export default {
    name: 'App',
    data(){
        return{
            isMainstreamBrowserShow:true
        }
    },
    created(){
        this.isMainstreamBrowser()
    },
    methods:{
        closeTip(){
            this.isMainstreamBrowserShow = true;
        },
        isMainstreamBrowser(){
            let userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
            let isOpera = userAgent.indexOf('Opera') >-1;
            if (isOpera) {
                this.isMainstreamBrowserShow = false
                return "Opera"
            }; //判断是否Opera浏览器
            if (userAgent.indexOf("Firefox") > -1) {
                return "FF";
            } //判断是否Firefox浏览器
            if (userAgent.indexOf("Chrome") > -1){
                return "Chrome";
            }
            if (userAgent.indexOf("Safari") > -1) {
                return "Safari";
            } //判断是否Safari浏览器
            if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera) {
                this.isMainstreamBrowserShow = false
                return "IE";
            }; //判断是否IE浏览器
            if((!!window.ActiveXObject || "ActiveXObject" in window)){
                this.isMainstreamBrowserShow = false
                return "IE";
            }
        }
    }
}
</script>

<style scoped lang="less">
  #app{
      position: relative;
    width: 100%;
    height: 100%;
    min-height: 100%;
  }
  .top-tip{
      width: 100%;
      height: 32px;
      line-height: 32px;
      padding: 0 24px;
      color: #464C5B;
      font-size: 14px;
      background-color: rgba(255,153,0,.1);;
  }
  .broswer-tips{
      width: 16px;
      height: 16px;
      vertical-align: top;
      margin-top: 8px;
      margin-right: 16px;
  }
  .broswer-close{
      width: 16px;
      height: 16px;
      vertical-align: top;
      margin-top: 8px;
      float: right;
      cursor: pointer;
  }
  
</style>
